<template>
    <div class="editor-row customize-editor-minimize">
        <div class="editor-row-title">{{ $t('auto.stringFormatterExtractphonenumberRegionCode') }}</div>
        <a-select v-model="clone.extract_phone_number.regionCode" style="width: 100%">
            <a-select-option value="TR">{{ $t('auto.stringFormatterExtractphonenumberTRkiyeTr') }}</a-select-option>
            <a-select-option value="US">{{ $t('auto.stringFormatterExtractphonenumberUnitedStatesUs') }}</a-select-option>
            <a-select-option value="GB">{{ $t('auto.stringFormatterExtractphonenumberUnitedKingdomGb') }}</a-select-option>
            <a-select-option value="DE">{{ $t('auto.stringFormatterExtractphonenumberGermanyDe') }}</a-select-option>
            <a-select-option value="FR">{{ $t('auto.stringFormatterExtractphonenumberFranceFr') }}</a-select-option>
            <a-select-option value="RU">{{ $t('auto.stringFormatterExtractphonenumberRussiaRu') }}</a-select-option>
            <a-select-option value="IN">{{ $t('auto.stringFormatterExtractphonenumberIndiaIn') }}</a-select-option>
            <a-select-option value="CN">{{ $t('auto.stringFormatterExtractphonenumberChinaCn') }}</a-select-option>
            <a-select-option value="JP">{{ $t('auto.stringFormatterExtractphonenumberJapanJp') }}</a-select-option>
            <a-select-option value="KR">{{ $t('auto.stringFormatterExtractphonenumberSouthKoreaKr') }}</a-select-option>
            <a-select-option value="BR">{{ $t('auto.stringFormatterExtractphonenumberBrazilBr') }}</a-select-option>
            <a-select-option value="AU">{{ $t('auto.stringFormatterExtractphonenumberAustraliaAu') }}</a-select-option>
            <a-select-option value="CA">{{ $t('auto.stringFormatterExtractphonenumberCanadaCa') }}</a-select-option>
        </a-select>
        <small class="description">
            {{ $t('auto.stringFormatterExtractphonenumberSelectTheRegionCodeToImprovePhoneNumberDetection') }}
        </small>
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";

const log = log2("StringFormatterExtractPhoneNumber");
export default {
    name: "StringFormatterExtractPhoneNumber",
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "string.extract_phone_number",
            value: "",
            extract_phone_number: {
                regionCode: "TR",
            },
        };
        return {
            clone,
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.editor-row {
    width: 100%;

    &.customize-editor-minimize {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    small.description {
        font-size: 10px;
        color: var(--color-text-weak-default);
    }

    .editor-row-title {
        font-weight: bold;
        font-size: 16px;
    }
}
</style> 